import { Link, useParams } from "react-router-dom";
import { projects } from "../data.js";
import { localizeBody, localizeField, localizeLinkLabel } from "../i18n.js";
import { BodyRenderer } from "./BodyRenderer.jsx";
import CopyLinkButton from "./CopyLinkButton.jsx";

export default function ProjectDetail({ t, copy, language }) {
  const { projectId } = useParams();
  const project = projects[projectId];

  if (!project) {
    return <div style={{ color: t.dim }}>{copy.projectNotFound}</div>;
  }

  return (
    <div>
      <Link
        to="/projects"
        style={{
          color: t.dim,
          display: "inline-block",
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: 12,
          marginBottom: 20,
          textDecoration: "none",
        }}
      >
        {copy.backProjects}
      </Link>

      <h2 style={{ fontSize: 23, fontWeight: 400, color: t.text, marginBottom: 8 }}>
        {localizeField(project, "title", language)}
      </h2>

      <div style={metaStyle}>
        <span style={{ color: t.dim }}>{project.year}</span>
        <CopyLinkButton t={t} copy={copy} />
        {project.links.map(([label, href]) =>
          label.toLowerCase().includes("private") ? (
            <span key={label} style={{ color: t.dim }}>
              {copy.private}
            </span>
          ) : (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: t.link, textDecoration: "none" }}
            >
              {localizeLinkLabel(label, language)} -&gt;
            </a>
          )
        )}
      </div>

      <BodyRenderer body={localizeBody(project, language)} t={t} copy={copy} />

      {project.technologies?.length > 0 && (
        <div style={{ marginTop: 40, fontSize: 14, color: t.dim }}>
          <strong style={{ color: t.text }}>{copy.technologiesUsed}</strong>{" "}
          {project.technologies.join(", ")}
        </div>
      )}
    </div>
  );
}

const metaStyle = {
  fontFamily: "'JetBrains Mono', monospace",
  fontSize: 12,
  marginBottom: 28,
  display: "flex",
  gap: 20,
  flexWrap: "wrap",
};
